import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { WorkProgressContent, WorkProgressStepper } from '../components';
import useWorkProgressSection from '../hooks/useWorkProgressSection';

export default function WorkProgressSection({ data }) {
  const { projectId } = useParams();

  const totalDrawings = data?.taskConfig?.totalDrawings ?? 0;
  const { taskList, workProgressSteps, refresh } = useWorkProgressSection({
    projectId,
    totalDrawings,
  });

  const [activeStep, setActiveStep] = useState(0);
  const handleStepClick = (stepIndex) => {
    const totalSteps = workProgressSteps.length;
    const newStep = stepIndex < 0 ? 0 : stepIndex >= totalSteps - 1 ? totalSteps - 1 : stepIndex;
    setActiveStep(newStep);
  };

  return (
    <>
      <WorkProgressStepper
        steps={workProgressSteps}
        activeStep={activeStep}
        onStepClick={handleStepClick}
      />
      <WorkProgressContent
        data={data}
        taskList={taskList}
        steps={workProgressSteps}
        activeStep={activeStep}
        refresh={refresh}
      />
    </>
  );
}
